document.querySelectorAll('.ct-section').forEach(section => {

  const tabs = section.querySelectorAll('.ct-tab-btn');

  const contents = section.querySelectorAll('.ct-tab-content');

  const viewAllBtn = section.querySelector('.ct-view-btn');

  /* TABS */

  tabs.forEach(tab => {

    tab.addEventListener('click', function(){

      tabs.forEach(btn => btn.classList.remove('active'));

      contents.forEach(content => content.classList.remove('active'));

      tab.classList.add('active');

      const target = section.querySelector('#' + tab.dataset.tab);

      if(target){
        target.classList.add('active');
      }

      if(viewAllBtn){
        viewAllBtn.href = tab.dataset.url;
        viewAllBtn.innerHTML = 'View all ' + tab.innerText;
      }

    });

  });

  /* WISHLIST */

  section.querySelectorAll('.ct-wishlist').forEach(btn => {

    btn.addEventListener('click', function(){

      btn.classList.toggle('active');

      btn.innerHTML = btn.classList.contains('active') ? '♥' : '♡';

    });

  });

  /* POPUP */

  section.querySelectorAll('.ct-quick-btn').forEach(btn => {

    btn.addEventListener('click', function(){

      const popup = section.querySelector('#' + btn.dataset.popup);

      if(popup){
        popup.classList.add('active');
      }

    });

  });

  section.querySelectorAll('.ct-popup-close').forEach(btn => {

    btn.addEventListener('click', function(){

      btn.closest('.ct-popup').classList.remove('active');

    });

  });

  section.querySelectorAll('.ct-popup-overlay').forEach(overlay => {

    overlay.addEventListener('click', function(){

      overlay.closest('.ct-popup').classList.remove('active');

    });

  });

  /* VARIANT + QUANTITY */

  section.querySelectorAll('.ct-popup').forEach(popup => {

    const variantSelect = popup.querySelector('.ct-variant');

    const hiddenVariant = popup.querySelector('.ct-hidden-variant-id');

    const qtyInput = popup.querySelector('.ct-qty-input');

    const hiddenQty = popup.querySelector('.ct-hidden-qty');

    if(variantSelect && hiddenVariant){

      hiddenVariant.value = variantSelect.value;

      variantSelect.addEventListener('change', function(){

        hiddenVariant.value = this.value;

      });

    }

    if(hiddenQty){
      hiddenQty.value = qtyInput.value;
    }

    popup.querySelector('.ct-plus')?.addEventListener('click', function(){

      qtyInput.value = parseInt(qtyInput.value) + 1;

      hiddenQty.value = qtyInput.value;

    });

    popup.querySelector('.ct-minus')?.addEventListener('click', function(){

      if(parseInt(qtyInput.value) > 1){

        qtyInput.value = parseInt(qtyInput.value) - 1;

        hiddenQty.value = qtyInput.value;

      }

    });

  });

  /* SLIDER */

  section.querySelectorAll('.ct-products-wrapper').forEach(wrapper => {

    const slider = wrapper.querySelector('.ct-products-grid');

    const nextBtn = wrapper.querySelector('.ct-slider-next');

    const prevBtn = wrapper.querySelector('.ct-slider-prev');

    if(!slider || !nextBtn || !prevBtn) return;

    const card = slider.querySelector('.ct-product-card');

    let scrollAmount = 400;

    if(card){
      scrollAmount = card.offsetWidth + 24;
    }

    nextBtn.addEventListener('click', function(){

      slider.scrollBy({
        left: scrollAmount,
        behavior:'smooth'
      });

    });

    prevBtn.addEventListener('click', function(){

      slider.scrollBy({
        left: -scrollAmount,
        behavior:'smooth'
      });

    });

  });

});